<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Modelo de Documentos</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Modelo de documentos',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn v-if="$check(user, ['documentmodels.create'])" 
                        id="btnNew" type="button" color="primary" elevation="0" to="/modelo-documentos/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                                        >Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="4" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="Procurar"
                                        v-model="dataList.filter.content" hide-details outlined clearable 
                                        @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-title class="table-card-title">Documentos</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum documento foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.updated_at`]="{ item }">
                                {{ item.updated_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon v-if="!$check(user, ['documentmodels.update'])"
                                    :disabled="!$check(user, ['documentmodels.find'])"
                                    @click="viewItem(item)" size="large" class="me-2">
                                    mdi-eye-outline
                                </v-icon>
                                <v-icon @click="viewItem(item)" size="large"
                                    class="me-2"
                                    :disabled="(!$check(user, ['documentmodels.update']))">
                                    mdi-pencil-outline
                                </v-icon>
                                <v-icon @click="remove(item)" size="large"
                                    :disabled="(!$check(user, ['documentmodels.delete']))">
                                    mdi-delete-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "DynamicTextList",

    data: () => ({
        user: null,
        dataset: {
            data: {}
        },
        dataList: {
            filter: {
                name: "",
               // client: "",
                unit: "",
               // status: ""
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Criado em", value: "created_at" },
                { text: "Atualizado em", value: "updated_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/document-models', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }

        },


        async remove(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja excluir o modelo de documento?',
                title: 'Excluir documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                await axios.delete(`/api/admin/document-models/${item.id}`)

                this.$dialog.notify.info("Modelo de documento excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataList.loading = false;
            }

        },


        viewItem(item) {
            this.$router.push(`modelo-documentos/${item.id}`);
        },
    },
};
</script>